import { DateHelper } from "@/Common/Helpers/DateHelper";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { Guid } from "@/Common/Models/Guid";
import { Person } from "@/Common/Models/Person/Person";
import { PortalRegistrationState } from "../Enums/PortalRegistrationState";
import { PatientProfileDto, SharedPatientDto, UserPermissionFlags } from "../MedfarPortal";

class PatientProfileMyleDto extends PatientProfileDto {
    public MyleId: Guid;
    public MyleType: string;
    public PortalSyncState: PortalRegistrationState;
}

class SharedPatientMyleDto extends SharedPatientDto {
    public MyleId: string;
    public MyleType: string;

    public FileIndex: number;
    public PermissionFlags: UserPermissionFlags;

    public static getAllPermissionFlags(): UserPermissionFlags {
        return (UserPermissionFlags.Dossier |
            UserPermissionFlags.Document |
            UserPermissionFlags.Message |
            UserPermissionFlags.Profile |
            UserPermissionFlags.Appointment |
            UserPermissionFlags.Billing);
    }

    public static areEqual(s: SharedPatientMyleDto, o: SharedPatientMyleDto): boolean {
        // all permissions is equal to -1 (FullControl)
        var permissionsEqual = (s.PermissionFlags == -1 && o.PermissionFlags == SharedPatientMyleDto.getAllPermissionFlags()) ||
            (o.PermissionFlags == -1 && s.PermissionFlags == SharedPatientMyleDto.getAllPermissionFlags()) ||
            (o.PermissionFlags == s.PermissionFlags);

        return o.FileIndex == s.FileIndex &&
            permissionsEqual &&
            o.DateOfBirth == s.DateOfBirth &&
            o.FirstName == s.FirstName &&
            o.PreferredName == s.PreferredName &&
            o.LastName == s.LastName &&
            o.MyleId == s.MyleId &&
            o.PatientProfileId == s.PatientProfileId &&
            o.PreferredLanguage == s.PreferredLanguage;
    }

    public static fromPerson(person: Person): SharedPatientMyleDto {
        let newShared = new SharedPatientMyleDto();
        newShared.PermissionFlags = SharedPatientMyleDto.getAllPermissionFlags();
        newShared.DateOfBirth = DateHelper.formatIsoFull(person.DateofBirth);
        newShared.FirstName = person.FirstName;
        newShared.PreferredName = person.PreferredName;
        newShared.LastName = person.LastName;
        newShared.FullName = NameHelper.formatFullNameForHasName(person);
        newShared.MyleId = person.ContactId;
        return newShared;
    }
}

export { PatientProfileMyleDto, SharedPatientMyleDto };
